import styled, { borderRadius } from "@rentiohq/web-theme";

const PHONE_MAX_WIDTH = "320px";
// Leaves room for the modal header, so an enlarged phone screen fits without
// scrolling.
const ENLARGED_PHONE_MAX_HEIGHT = "calc(100vh - 200px)";

export const Frame = styled.div<{ isPhone?: boolean }>`
  width: 100%;
  max-width: ${({ isPhone }) => (isPhone ? PHONE_MAX_WIDTH : "100%")};
  margin: 0 auto;
  border: 1px solid ${({ theme }) => theme.colors.neutral30};
  border-radius: ${borderRadius("large")};
  overflow: hidden;
  background: ${({ theme }) => theme.colors.neutral10};
`;

export const ZoomButton = styled.button`
  display: block;
  width: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  background: none;
  cursor: zoom-in;
`;

export const Image = styled.img`
  display: block;
  width: 100%;
  height: auto;
`;

export const EnlargedImage = styled.img<{ isPhone?: boolean }>`
  display: block;
  max-width: 100%;
  max-height: ${({ isPhone }) =>
    isPhone ? ENLARGED_PHONE_MAX_HEIGHT : "none"};
  height: auto;
  margin: 0 auto;
`;

export const Video = styled.video`
  display: block;
  width: 100%;
  height: auto;
`;
